<template>
    <div>
      <LoginForm />
    </div>
  </template>
  
  <script>
  import LoginForm from '../components/LoginForm.vue';
  
  export default {
    components: {
      LoginForm
    }
  }
  </script>
  